import { medicalMessagesFrCA } from './lib/intl/fr-CA';
import { medicalMessagesFR } from './lib/intl/fr';
import { medicalMessagesDE } from './lib/intl/de';
import { medicalMessagesEnGB } from './lib/intl/en-GB';
import { medicalMessagesEN } from './lib/intl/en-US';

export const programId = '5f2af43788b29b18718a95c7';

export const defaultOptions = {
    restApi: {
        serviceUrl: 'https://services.sheerid.com/',
    },

    logLevel: 'error',
    useFingerprinting: true,
    messagesWithLocale: {
        'en-US': medicalMessagesEN,
        'en-GB': medicalMessagesEnGB,
        de: medicalMessagesDE,
        fr: medicalMessagesFR,
        'fr-CA': medicalMessagesFrCA,
    },
};
